/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.37
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ArrivalResponse } from '../model/models';
import { DatedVehicleJourney } from '../model/models';
import { DatedVehicleJourneyResponse } from '../model/models';
import { DepartureResponse } from '../model/models';
import { Problem } from '../model/models';
import { StationboardStopEnum } from '../model/models';
import { TrainStopAssignmentResponse } from '../model/models';
import { TrainStopAssignmentsEnum } from '../model/models';
import { TransportModeEnum } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class VehicleJourneysV3Service {

    protected basePath = 'https://journey-service.api.sbb.ch';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get complete DatedVehicleJourney by its Journey-Reference.
     * This will deliver all current details of the complete vehicle-journey (of the passenger carrying &#x60;ServiceProduct&#x60; such such as train, bus,..). It contains a list of all &#x60;ScheduledStopPoints&#x60; including departure and arrival times (with real-time data if available) and additional information like specific Notice\&#39;s. &lt;br/&gt;The response can be cached during 15 seconds.
     * @param id Any &#x60;ServiceJourney::id&#x60; given by PTRideLeg or any other Vehicle-Journey response. Or SJYID (e.g. ch:1:sjyid:100046:11238-001).
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param date Day of operation (must be specified, if querring with SJYID).
     * @param includeOperatingDays Set true to get &#x60;ServiceJourney::operatingPeriods&#x60;.
     * @param includeRouteProjection With or without a plottable polyline for each vehicle-journey (if available).&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeIntermediateStops Whether the &#x60;PTRideLeg\&#39;s&#x60; should include intermediate stops (between the passenger\&#39;s board and alight in &#x60;ServiceJourney::stopPoints&#x60;).&lt;br&gt;x-extensible-enum:  [ALL,NONE,BOARDING_ALIGHTING] where ALL is BOARDING_ALIGHTING plus virtual stops.
     * @param includeTrainStopAssignments Whether &#x60;PTRideLeg\&#39;s&#x60; should include &#x60;CompoundTrain\&#39;s&#x60;(aka formation, composition). However, &#x60;CompoundTrain\&#39;s&#x60; at any &#x60;ScheduledStopPoint&#x60; on the &#x60;ServiceJourney&#x60; may be loaded separately by &#x60;/v3/vehicle-journeys/by-stoppoints&#x60;. Possible values: - NONE none at all, though a &#x60;PTRideLeg::trainStopAssignmentHint&#x60; is always given. - ORIGIN  &#x60;TrainStopAssignment\&#39;s&#x60; are added to first (departure) &#x60;ScheduledStopPoint&#x60; of each &#x60;PTRideLeg&#x60;  - ORIGIN_DESTINATION &#x60;TrainStopAssignment\&#39;s&#x60; are added to first (departure) and last (arrival) &#x60;ScheduledStopPoint&#x60; of each &#x60;PTRideLeg&#x60; having a &#x60;TrainStopAssignment&#x60; resp. a &#x60;CompoundTrain&#x60;.
     * @param includeExitSide Add exit-side at each stop, if available. Needs &#x60;date&#x60; and allocated &#x60;ServiceProduct&#x60;.&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeAccessibility Accessibility hints on &#x60;ScheduledStopPoint\&#39;s&#x60;.&lt;br&gt;x-extensible-enum: see enum values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatedVehicleJourneyById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, includeOperatingDays?: boolean, includeRouteProjection?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<DatedVehicleJourney>;
    public getDatedVehicleJourneyById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, includeOperatingDays?: boolean, includeRouteProjection?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<DatedVehicleJourney>>;
    public getDatedVehicleJourneyById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, includeOperatingDays?: boolean, includeRouteProjection?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<DatedVehicleJourney>>;
    public getDatedVehicleJourneyById(id: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, includeOperatingDays?: boolean, includeRouteProjection?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeTrainStopAssignments?: TrainStopAssignmentsEnum, includeExitSide?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDatedVehicleJourneyById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (includeOperatingDays !== undefined && includeOperatingDays !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeOperatingDays, 'includeOperatingDays');
        }
        if (includeRouteProjection !== undefined && includeRouteProjection !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeRouteProjection, 'includeRouteProjection');
        }
        if (includeIntermediateStops !== undefined && includeIntermediateStops !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeIntermediateStops, 'includeIntermediateStops');
        }
        if (includeTrainStopAssignments !== undefined && includeTrainStopAssignments !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeTrainStopAssignments, 'includeTrainStopAssignments');
        }
        if (includeExitSide !== undefined && includeExitSide !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeExitSide, 'includeExitSide');
        }
        if (includeAccessibility !== undefined && includeAccessibility !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeAccessibility, 'includeAccessibility');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DatedVehicleJourney>(`${this.configuration.basePath}/v3/vehicle-journeys/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get vehicle-journeys by &#x60;ServiceProduct&#x60; reference (aka train-search).
     * Determines complete journey-details (aka de:Fahrt/Zuglauf) matching given parameters.
     * @param serviceProductReference Reference to an operating vehicle (&#x60;ServiceProduct&#x60; of a Line or a route),see [**ServiceProductReference**](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md#serviceproductreference).&lt;br&gt;Results might not be 100% exact for e.g. a filter like \&#39;IC 714\&#39; might also result in \&#39;IC **1** 714\&#39; but a filter like \&#39;IC 1 714\&#39; will not resolve \&#39;IC 714\&#39;!
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param date Day of operation (relates to departure-time) at very origin StopPlace. If not provided, all matching &#x60;ServiceProduct\&#39;s&#x60; of the current &#x60;ServiceCalendar&#x60; (timetable-period) will be resolved.&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param time Local time (seconds will be ignored) of operation (relates to date) at departure station according to scheduled data. If not provided, the whole day is taken into account.
     * @param limit Number of hits to be found (max&#x3D;50). If limit&#x3D;1, sorting related to input parameters (Line and operatorNumbers) is applied to determine best result, where limit greater than 1 results are returned as is (by underlying router).
     * @param operatorReferences Operators involved on &#x60;ServicProduct&#x60;. Variants supported: - number (like \&#39;11\&#39; for SBB) - number 0-padded to 6 digits (as returned by &#x60;Operator::id&#x60; like \&#39;000033\&#39; for BLS) - _Swiss Business Organisation Id (SBOID)_ - full name or abbreviation both in several languages, see [OpenTransportData.swiss \&#39;Business organisation\&#39;](https://opentransportdata.swiss/en/dataset/business-organisations).
     * @param restrictCH Restricts to CH only if set to true, or false if confusions with similar international lines like Finland\&#39;s \&#39;IC 1\&#39; are ok.
     * @param regionNumber Region-number as given in &#x60;ServiceJourney:::notices -&gt; Notice::type&#x3D;\&#39;INFO\&#39;, ::key&#x3D;\&#39;RN\&#39;&#x60; (relevant for Postauto AG (PAG) operations-reference).
     * @param includeExitSide Add exit-side at each stop, if available. Needs &#x60;date&#x60; and allocated &#x60;ServiceProduct&#x60;.&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeIntermediateStops Whether the &#x60;PTRideLeg\&#39;s&#x60; should include intermediate stops (between the passenger\&#39;s board and alight in &#x60;ServiceJourney::stopPoints&#x60;).&lt;br&gt;x-extensible-enum:  [ALL,NONE,BOARDING_ALIGHTING] where ALL is BOARDING_ALIGHTING plus virtual stops.
     * @param includeAccessibility Accessibility hints on &#x60;ScheduledStopPoint\&#39;s&#x60;.&lt;br&gt;x-extensible-enum: see enum values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatedVehicleJourneysByService(serviceProductReference: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, limit?: number, operatorReferences?: Array<string>, restrictCH?: boolean, regionNumber?: string, includeExitSide?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeAccessibility?: 'NONE' | 'ALL', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<DatedVehicleJourneyResponse>;
    public getDatedVehicleJourneysByService(serviceProductReference: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, limit?: number, operatorReferences?: Array<string>, restrictCH?: boolean, regionNumber?: string, includeExitSide?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeAccessibility?: 'NONE' | 'ALL', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<DatedVehicleJourneyResponse>>;
    public getDatedVehicleJourneysByService(serviceProductReference: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, limit?: number, operatorReferences?: Array<string>, restrictCH?: boolean, regionNumber?: string, includeExitSide?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeAccessibility?: 'NONE' | 'ALL', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<DatedVehicleJourneyResponse>>;
    public getDatedVehicleJourneysByService(serviceProductReference: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, limit?: number, operatorReferences?: Array<string>, restrictCH?: boolean, regionNumber?: string, includeExitSide?: boolean, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeAccessibility?: 'NONE' | 'ALL', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {
        if (serviceProductReference === null || serviceProductReference === undefined) {
            throw new Error('Required parameter serviceProductReference was null or undefined when calling getDatedVehicleJourneysByService.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (time !== undefined && time !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>time, 'time');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (operatorReferences) {
            operatorReferences.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'operatorReferences');
            })
        }
        if (restrictCH !== undefined && restrictCH !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>restrictCH, 'restrictCH');
        }
        if (regionNumber !== undefined && regionNumber !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>regionNumber, 'regionNumber');
        }
        if (includeExitSide !== undefined && includeExitSide !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeExitSide, 'includeExitSide');
        }
        if (includeIntermediateStops !== undefined && includeIntermediateStops !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeIntermediateStops, 'includeIntermediateStops');
        }
        if (includeAccessibility !== undefined && includeAccessibility !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeAccessibility, 'includeAccessibility');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DatedVehicleJourneyResponse>(`${this.configuration.basePath}/v3/vehicle-journeys/by-service/${encodeURIComponent(String(serviceProductReference))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get vehicle-journeys by car-identifier (carUIC oder BeaconID).
     * Determines complete journey-details (aka de:Fahrt/Zuglauf) matching given parameters.
     * @param vehicleId UIC number of a concrete Car within a formation. Various (numeric) formats are possible: a) Beacon MajorId &#x3D; 15003, b) FOS CarUIC with or without whitespaces and hyphen like \&#39;94 85 123 123 - 2\&#39; or \&#39;94851231232\&#39;
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param date Unique date of operation. Default is NOW
     * @param time Time (seconds will be ignored) of operation related to date (defaults to NOW), see offsetBeforeDateTime. Default is NOW
     * @param includeIntermediateStops Whether the &#x60;PTRideLeg\&#39;s&#x60; should include intermediate stops (between the passenger\&#39;s board and alight in &#x60;ServiceJourney::stopPoints&#x60;).&lt;br&gt;x-extensible-enum:  [ALL,NONE,BOARDING_ALIGHTING] where ALL is BOARDING_ALIGHTING plus virtual stops.
     * @param includeVehicleSpeakerMessage Include vocal speaker messages on vehicle. The content corresponds to original VIA-speaker messages, but may differ from actually spoken message by operating crew on board of vehicle. Interprete them with a grain of salt.&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param includeAccessibility Accessibility hints on &#x60;ScheduledStopPoint\&#39;s&#x60;.&lt;br&gt;x-extensible-enum: see enum values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatedVehicleJourneysByVehicleId(vehicleId: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeVehicleSpeakerMessage?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<DatedVehicleJourneyResponse>;
    public getDatedVehicleJourneysByVehicleId(vehicleId: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeVehicleSpeakerMessage?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<DatedVehicleJourneyResponse>>;
    public getDatedVehicleJourneysByVehicleId(vehicleId: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeVehicleSpeakerMessage?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<DatedVehicleJourneyResponse>>;
    public getDatedVehicleJourneysByVehicleId(vehicleId: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, time?: string, includeIntermediateStops?: 'ALL' | 'BOARDING_ALIGHTING' | 'NONE', includeVehicleSpeakerMessage?: boolean, includeAccessibility?: 'NONE' | 'ALL', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {
        if (vehicleId === null || vehicleId === undefined) {
            throw new Error('Required parameter vehicleId was null or undefined when calling getDatedVehicleJourneysByVehicleId.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (time !== undefined && time !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>time, 'time');
        }
        if (includeIntermediateStops !== undefined && includeIntermediateStops !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeIntermediateStops, 'includeIntermediateStops');
        }
        if (includeVehicleSpeakerMessage !== undefined && includeVehicleSpeakerMessage !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeVehicleSpeakerMessage, 'includeVehicleSpeakerMessage');
        }
        if (includeAccessibility !== undefined && includeAccessibility !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeAccessibility, 'includeAccessibility');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DatedVehicleJourneyResponse>(`${this.configuration.basePath}/v3/vehicle-journeys/by-vehicle/${encodeURIComponent(String(vehicleId))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get &#x60;TrainStopAssignment\&#39;s&#x60; for a &#x60;ServiceJourney&#x60; at given stops.
     * Returns known &#x60;TrainStopAssignment\&#39;s&#x60; for the given &#x60;ServiceJourney::id&#x60; matching the given &#x60;StopPlace\&#39;s&#x60;, if found, or null otherwise. Returns NOT-FOUND (HTTP 404) if no &#x60;TrainStopAssignment\&#39; is found for any given stop. &#x60;StopPlace\&#39;s&#x60; requested must relate to passing &#x60;ScheduledStopPoint\&#39;s&#x60; on the &#x60;ServiceJourney&#x60;.
     * @param id Any &#x60;ServiceJourney::id&#x60; given by PTRideLeg or any other Vehicle-Journey response. Or SJYID (e.g. ch:1:sjyid:100046:11238-001).
     * @param placeReferences &#x60;StopPlace\&#39;s&#x60; of interest related to &#x60;ScheduledStopPoint\&#39;s&#x60; on &#x60;ServiceJourney&#x60; with potential &#x60;TrainStopAssignment\&#39;s&#x60;. See v3 PlaceReference in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param date Day of operation (must be specified, if querring with SJYID).
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTrainStopAssignmentsByServiceJourneyId(id: string, placeReferences: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<TrainStopAssignmentResponse>;
    public getTrainStopAssignmentsByServiceJourneyId(id: string, placeReferences: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<TrainStopAssignmentResponse>>;
    public getTrainStopAssignmentsByServiceJourneyId(id: string, placeReferences: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<TrainStopAssignmentResponse>>;
    public getTrainStopAssignmentsByServiceJourneyId(id: string, placeReferences: Array<string>, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', date?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTrainStopAssignmentsByServiceJourneyId.');
        }
        if (placeReferences === null || placeReferences === undefined) {
            throw new Error('Required parameter placeReferences was null or undefined when calling getTrainStopAssignmentsByServiceJourneyId.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (placeReferences) {
            placeReferences.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'placeReferences');
            })
        }
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<TrainStopAssignmentResponse>(`${this.configuration.basePath}/v3/vehicle-journeys/${encodeURIComponent(String(id))}/by-stoppoints`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get arrivals at a StopPlace.
     * Determines next arrivals at a given Stop and point in time within a duration (the results always contain all departures running to the last minute found even if the requested maximum limit was overrun).
     * @param destination StopPlace for which arrivals shall be retrieved. See v3 **PlaceReference** in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param restrictDestination Set &#x60;CONCRETE_STOP&#x60; for arrivals passing that exact destination or &#x60;EQUIVALENT_STOPS&#x60; including equivalent Stops (such as Meta StopPlace\&#39;s).&lt;br&gt;x-extensible-enum: 
     * @param direction If only vehicles departing from a certain direction shall be returned, specify the direction (StopPlace only yet). See v3 **PlaceReference** in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @param date (Local) date at arrival, defaults to TODAY.
     * @param time Local time at arrival, defaults to NOW (seconds will be ignored).
     * @param limit Maximum number of results to be returned, related to parameter &#x60;duration&#x60; and may reduce or expand &#x60;limit&#x60; settings.
     * @param duration Interval duration [min.] (0..1439) to consider. Relates to parameter &#x60;limit&#x60;, which will limit results within the duration.
     * @param includeTransportModes Optionally restrict to a requestable set of SBB specific TransportMode\&#39;s (aka OJP PTMode). The set is relevant for any vehicle-journey (&#x60;DatedVehicleJourney&#x60;, &#x60;PTRideLeg&#x60;, ..). Relates to &#x60;ServiceProduct::vehicleMode&#x60; and &#x60;::vehicleSubModes&#x60;. - Default: non-restricted (null or empty-list), by means all TransportMode\&#39;s are searched. - If some choice is made, other TransportMode\&#39;s are excluded implicitely. - To get TRAIN (VehicleMode::id) only, add: [HIGH_SPEED_TRAIN,INTERCITY,INTERREGIO,REGIO,URBAN_TRAIN,SPECIAL_TRAIN] &gt;- Be aware that TRAMWAY also searches for METRO (not distinguished it here further!) - Also there is no exact possibility to distinguish more precisely between CABLEWAY_GONDOLA_CHAIRLIFT_FUNICULAR at search time&lt;br&gt;&lt;br&gt;x-extensible-enum: 
     * @param includeQuays Restrict departures optionally from given tracks (related to origin).
     * @param includeRank Calculate StopPoint::rank, which might be used by consumers to consider relevant intermediates stops to display.&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVehicleJourneysByArrivalAtDestination(destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictDestination?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<ArrivalResponse>;
    public getVehicleJourneysByArrivalAtDestination(destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictDestination?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<ArrivalResponse>>;
    public getVehicleJourneysByArrivalAtDestination(destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictDestination?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<ArrivalResponse>>;
    public getVehicleJourneysByArrivalAtDestination(destination: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictDestination?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {
        if (destination === null || destination === undefined) {
            throw new Error('Required parameter destination was null or undefined when calling getVehicleJourneysByArrivalAtDestination.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (restrictDestination !== undefined && restrictDestination !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>restrictDestination, 'restrictDestination');
        }
        if (direction !== undefined && direction !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>direction, 'direction');
        }
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (time !== undefined && time !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>time, 'time');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (duration !== undefined && duration !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>duration, 'duration');
        }
        if (includeTransportModes) {
            includeTransportModes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'includeTransportModes');
            })
        }
        if (includeQuays) {
            includeQuays.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'includeQuays');
            })
        }
        if (includeRank !== undefined && includeRank !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeRank, 'includeRank');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<ArrivalResponse>(`${this.configuration.basePath}/v3/vehicle-journeys/by-arrival/${encodeURIComponent(String(destination))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get departures starting at a StopPlace.
     * Determines next departures from a Stop and point in time within duration (the results always contain all departures running to the last minute found even if the requested maximum limit was overrun).
     * @param origin Starting StopPlace of the Departure. See v3 **PlaceReference** in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param acceptLanguage Language of translatable properties.
     * @param restrictOrigin Set &#x60;CONCRETE_STOP&#x60; for departures passing that exact origin or &#x60;EQUIVALENT_STOPS&#x60; including equivalent Stops (such as Meta StopPlace\&#39;s).&lt;br&gt;x-extensible-enum: 
     * @param direction If only vehicles departing to a certain direction shall be returned, specify the direction StopPlace. See v3 **PlaceReference** in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @param date (Local) date at origin, defaults to TODAY.
     * @param time Local time at origin, defaults to NOW (seconds will be ignored).
     * @param limit Maximum number of results to be returned, related to parameter &#x60;duration&#x60; and may reduce or expand &#x60;limit&#x60; settings.
     * @param duration Interval duration [min.] (0..1439) to consider. Relates to parameter &#x60;limit&#x60;, which will limit results within the duration.
     * @param includeTransportModes Optionally restrict to a requestable set of SBB specific TransportMode\&#39;s (aka OJP PTMode). The set is relevant for any vehicle-journey (&#x60;DatedVehicleJourney&#x60;, &#x60;PTRideLeg&#x60;, ..). Relates to &#x60;ServiceProduct::vehicleMode&#x60; and &#x60;::vehicleSubModes&#x60;. - Default: non-restricted (null or empty-list), by means all TransportMode\&#39;s are searched. - If some choice is made, other TransportMode\&#39;s are excluded implicitely. - To get TRAIN (VehicleMode::id) only, add: [HIGH_SPEED_TRAIN,INTERCITY,INTERREGIO,REGIO,URBAN_TRAIN,SPECIAL_TRAIN] &gt;- Be aware that TRAMWAY also searches for METRO (not distinguished it here further!) - Also there is no exact possibility to distinguish more precisely between CABLEWAY_GONDOLA_CHAIRLIFT_FUNICULAR at search time&lt;br&gt;&lt;br&gt;x-extensible-enum: 
     * @param includeQuays Restrict departures optionally from given tracks (related to origin).
     * @param includeRank Calculate StopPoint::rank, which might be used by consumers to consider relevant intermediate stops to display.&lt;br&gt;This parameter has an impact on performance and/or response volume, set wisely!
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVehicleJourneysByDepartureAtOrigin(origin: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictOrigin?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<DepartureResponse>;
    public getVehicleJourneysByDepartureAtOrigin(origin: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictOrigin?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpResponse<DepartureResponse>>;
    public getVehicleJourneysByDepartureAtOrigin(origin: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictOrigin?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<HttpEvent<DepartureResponse>>;
    public getVehicleJourneysByDepartureAtOrigin(origin: string, requestID?: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', restrictOrigin?: StationboardStopEnum, direction?: string, date?: string, time?: string, limit?: number, duration?: number, includeTransportModes?: Array<TransportModeEnum>, includeQuays?: Array<string>, includeRank?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/problem+json' | 'application/json'}): Observable<any> {
        if (origin === null || origin === undefined) {
            throw new Error('Required parameter origin was null or undefined when calling getVehicleJourneysByDepartureAtOrigin.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (restrictOrigin !== undefined && restrictOrigin !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>restrictOrigin, 'restrictOrigin');
        }
        if (direction !== undefined && direction !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>direction, 'direction');
        }
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (time !== undefined && time !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>time, 'time');
        }
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (duration !== undefined && duration !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>duration, 'duration');
        }
        if (includeTransportModes) {
            includeTransportModes.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'includeTransportModes');
            })
        }
        if (includeQuays) {
            includeQuays.forEach((element) => {
                queryParameters = this.addToHttpParams(queryParameters,
                  <any>element, 'includeQuays');
            })
        }
        if (includeRank !== undefined && includeRank !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>includeRank, 'includeRank');
        }

        let headers = this.defaultHeaders;
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/problem+json',
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DepartureResponse>(`${this.configuration.basePath}/v3/vehicle-journeys/by-departure/${encodeURIComponent(String(origin))}`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
